var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlacklist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13978_13146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0699 16.8135H40.4999",
    stroke: "#1D1D1D",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.48 18.7935C6.57352 18.7935 7.46 17.907 7.46 16.8135C7.46 15.72 6.57352 14.8335 5.48 14.8335C4.38648 14.8335 3.5 15.72 3.5 16.8135C3.5 17.907 4.38648 18.7935 5.48 18.7935Z",
    stroke: "#1D1D1D",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.09 27.4839H11.08",
    stroke: "#1D1D1D",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.48 29.4639C6.57352 29.4639 7.46 28.5774 7.46 27.4839C7.46 26.3904 6.57352 25.5039 5.48 25.5039C4.38648 25.5039 3.5 26.3904 3.5 27.4839C3.5 28.5774 4.38648 29.4639 5.48 29.4639Z",
    stroke: "#1D1D1D",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0699 6.14355H40.4999",
    stroke: "#1D1D1D",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.48 8.12357C6.57352 8.12357 7.46 7.2371 7.46 6.14357C7.46 5.05005 6.57352 4.16357 5.48 4.16357C4.38648 4.16357 3.5 5.05005 3.5 6.14357C3.5 7.2371 4.38648 8.12357 5.48 8.12357Z",
    stroke: "#1D1D1D",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4899 38.1436H11.0699",
    stroke: "#1D1D1D",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.48 40.1236C6.57352 40.1236 7.46 39.2371 7.46 38.1436C7.46 37.05 6.57352 36.1636 5.48 36.1636C4.38648 36.1636 3.5 37.05 3.5 38.1436C3.5 39.2371 4.38648 40.1236 5.48 40.1236Z",
    stroke: "#1D1D1D",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5 30.8936C40.5 25.923 36.4706 21.8936 31.5 21.8936C26.5294 21.8936 22.5 25.923 22.5 30.8936C22.5 35.8641 26.5294 39.8936 31.5 39.8936C36.4706 39.8936 40.5 35.8641 40.5 30.8936Z",
    stroke: "#1D1D1D",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.14 37.2534L37.86 24.5234",
    stroke: "#1D1D1D",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13978_13146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.3,
    height: 37.27,
    fill: "white",
    transform: "translate(2.84998 3.51367)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlacklist);
export default __webpack_public_path__ + "static/media/blacklist.39725a9ae4a8ff2cd052425b6876ea16.svg";
export { ForwardRef as ReactComponent };